import React from "react";
// Import the enhanced version for better UI
import VideoListEnhanced from "./VideoListEnhanced";

export default function VideoList({ studioId, onVideoSelect, isOwner }) {
  // Use the enhanced version for better YouTube/Netflix-like UI
  // Note: onVideoSelect is ignored as VideoListEnhanced now navigates directly to video player
  return <VideoListEnhanced studioId={studioId} isOwner={isOwner} />;
}